// Ethraeon Systems public marketing app entry
// (c) S. Jason Prohaska (ingombrante) 2024-2026

import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./styles/eth-brand.css";
import "./styles/global.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
